import React from "react";
import { useLocation } from "react-router-dom";
import { CustomReactTable } from "../../Component/Common/CustomReactTable";

export function Family() {
  const location = useLocation();
  const familyData = location.state || [];

  const columns = React.useMemo(
    () => [
      { Header: "Sr No", accessor: "sr_no" },
      { Header: "Full Name", accessor: "full_name_e" },
      { Header: "Age", accessor: "age" },
      { Header: "Gender", accessor: "gender_e" },
      { Header: "House No", accessor: "house_no" },
      { Header: "Assembly No", accessor: "assembly_no" },
      { Header: "Booth No", accessor: "booth_no" },
      { Header: "EPIC No", accessor: "epic_no" },
      { Header: "Party Name", accessor: "party_name" },
      { Header: "Address", accessor: "address_e" },
      { Header: "Mobile No", accessor: "mobile_no" },
    ],
    []
  );

  return (
    <>
      <h1 className="Family">Family Details</h1>
      {familyData.length > 0 ? (
        <CustomReactTable
          data={familyData}
          columns={columns}
          tableLoading={false} // Pass loading state if applicable
          noDataText="No family details available."
          type="family"
        />
      ) : (
        <p>No family details available.</p>
      )}
    </>
  );
}
